import { memo } from 'react';

import { CreditIcon } from '@air/next-icons';
import { Chip } from '@air/primitive-chip';

import { formatDuration } from './formatDuration';

type ModelCostBadgeProps = {
  credits?: number;
  durationMs?: number;
};

export const ModelCostBadge = memo(({ credits, durationMs }: ModelCostBadgeProps) => (
  <Chip className="gap-px" color="grey" shape="rectangular" size="small">
    {credits !== undefined && (
      <span className="inline-flex items-center gap-1">
        <CreditIcon className="size-4 shrink-0" />
        {credits}
      </span>
    )}
    {credits !== undefined && durationMs !== undefined && <span className="text-gray-9">&nbsp;&middot;&nbsp;</span>}
    {durationMs !== undefined && formatDuration(durationMs)}
  </Chip>
));

ModelCostBadge.displayName = 'ModelCostBadge';
